// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"K4-z","dimensionLabel":"L4-z","styleChooserControlWrapper":"M4-z","styleChooserControl":"N4-z","disabled":"O4-z","giftCard":"P4-z","styleChooserText":"Q4-z"};